import type { NextPage } from "next"
import Head from "next/head"
import Image from "next/image"
import { FeatureCard } from "../src/components/cards/FeatureCard"
import { NavBar } from "../src/components/universal/NavBar"
import { Footer } from "../src/components/universal/Footer"
import { PageShade } from "../src/components/universal/PageShade"
import { PageHeader } from "../src/components/universal/PageHeader"
import { DownloadLinks } from "../src/components/DownloadLinks"
import { SectionHeader } from "../src/components/elements/SectionHeader"
import { FeaturesPageHead } from "../src/components/FeaturesPageHead"
import { PageMeta } from "../src/components/universal/PageMeta"

// Images

import browserdeals from "/public/images/features/browser-deals2.png"
import autofill from "/public/images/features/autofill2.png"
import aipowered from "/public/images/features/aipowered.png"
import savedItems from "/public/images/features/redeem2.png"
import search from "/public/images/features/search2.png"
import redeem from "/public/images/features/redeem2.png"
import gcow from "/public/images/features/redeem-rewards.png"
import stacked from "/public/images/features/stacked.png"
import { DownloadCTA } from "../src/components/universal/DownloadCTA"

const Features: NextPage = () => {
  return (
    <div>
      <PageMeta
        title={"Features"}
        theme={"#F3F4F7"}
        description={"Discover how Ruby helps you have unlimited saving potential."}
      />

      <main className='features-page'>
        <NavBar />

        <FeaturesPageHead />

        <PageHeader
          title='Explore Ruby'
          caption='Discover how Ruby helps you have unlimited saving potential.'
          center
        />

        <section>
          <div className='wrapper cards-wrapper'>
            <FeatureCard
              accent='#BDA6FF'
              vertical={true}
              title={"AI-powered savings recommendations"}
              image={aipowered}
              caption='Ruby learns how you like to shop, then creates personalized coupons, made for you to save the most.'
            />

            <FeatureCard
              accent='#FFA6CB'
              title={"Instant Promo Codes at Your Fingertips - No More Searching!"}
              image={search}
              caption={
                "For ultimate flexibility. Find the best place to get those new sneakers, search for smart watch deals, or explore all the ways to save at one store."
              }
            />

            {/* Browser --------------------------- */}
            <SectionHeader
              title={"Ruby Safari Extension for iPhones"}
              caption='Shop like normal. Save like crazy. Ruby Extension makes it easy to get cashback while shopping in iPhone Safari browser.'
            />
            <FeatureCard
              compact={true}
              halfWidth={true}
              accent='#C9E5FF'
              title={"Get cashback at over 40K stores"}
              caption={`One tap of a button to unlock cashback at most US retailers.`}
              image={browserdeals}
            />
            <FeatureCard
              compact
              halfWidth
              reverse
              vertical
              accent='#C9E5FF'
              title={"Earn while you spend with the best Cashback in the market."}
              // caption={`Having autofill at any website and any form makes life a bit easier.`}
              image={redeem}
            />
            {/* <FeatureCard
              compact
              halfWidth
              reverse
              vertical
              accent='#C9E5FF'
              title={"Autofill at any store"}
              caption={`Having autofill at any website and any form makes life a bit easier.`}
              image={autofill}
            /> */}

            {/* Rewards --------------------------- */}
            <SectionHeader
              title={"Stacked Savings"}
              caption={
                "Forget hours of research and reading T&Cs. Ruby combines the best ways to save to get you the biggest discount."
              }
            />
            <FeatureCard
              compact={true}
              halfWidth={true}
              accent='#FFDDC8'
              title={"Every way to save"}
              caption='Cash back, points, limited-time sales… Ruby calculates every single saving available and stacks it all for you. No more post-checkout regrets.'
              image={stacked}
            />
            <FeatureCard
              compact={true}
              halfWidth={true}
              accent='#FFDDC8'
              title={"Redeem your rewards"}
              caption='Earn Cashback every time you shop, and redeem it as cash payout or gift cards.'
              image={gcow}
            />

            {/* Saved --------------------------- */}
            <FeatureCard
              accent='#B2FFC3'
              title={"Unlock the Highest Cash Back Rewards – Guaranteed 5% Minimum!"}
              // caption='Build a wishlist, prep your holiday lookbook, and collect coupons. Just create and name a collection, then start saving the best products and deals.'
              image={savedItems}
            />
            {/* <FeatureCard
              accent='#B2FFC3'
              title={"Saved & Collections"}
              caption='Build a wishlist, prep your holiday lookbook, and collect coupons. Just create and name a collection, then start saving the best products and deals.'
              image={savedItems}
            /> */}
          </div>
        </section>
        
        <section>
          <div className='wrapper'>
            <DownloadCTA />
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Features
